// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AttchmentContent {
  margin: auto;
  text-align: left;
  padding: none;
}

.item-inner {
  margin: 0% !important;
}

.sample {
  font-size: 1rem;
}

.ion-md-download:before {
  content: "\\f2e3";
  position: relative;
  left: 10px;
}

.local-text-position {
  font-size: 10px !important;
  color: var(--ion-color-step-1250) !important;
  margin-top: 2px !important;
}

.local-bgColor {
  background-color: transparent;
}

.local-text-color {
  color: var(--ion-color-primary) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/excel-csv-upload/excel-csv-upload.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AACF;;AACA;EACE,qBAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AADA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;AAIF;;AADA;EACE,0BAAA;EACA,4CAAA;EACA,0BAAA;AAIF;;AAFA;EACE,6BAAA;AAKF;;AAHA;EACE,0CAAA;AAMF","sourcesContent":[".AttchmentContent {\n  margin: auto;\n  text-align: left;\n  padding: none;\n}\n.item-inner {\n  margin: 0% !important;\n}\n.sample {\n  font-size: 1rem;\n}\n.ion-md-download:before {\n  content: \"\\f2e3\";\n  position: relative;\n  left: 10px;\n}\n\n.local-text-position {\n  font-size: 10px !important;\n  color: var(--ion-color-step-1250) !important;\n  margin-top: 2px !important;\n}\n.local-bgColor {\n  background-color: transparent;\n}\n.local-text-color {\n  color: var(--ion-color-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
